/**
 * Calculate the filter to apply to the raw data to get the data corresponding to the selected bar
 * @param interval the size of each interval bin (e.g 10)
 * @param intervalValue the value of the interval bin (e.g 15, 25, 35, etc.)
 * @param xKey the key of the x axis (e.g "agent.age")
 * @param xValue the value of the y axis on the given X interval
 * @returns an object with the dimension field as key and the min and max of the interval as value
 */
export const getHistogramRawDataFilterWithInterval = ({
    interval,
    intervalValue,
    xKey,
    xValue,
}: {
    interval: number;
    intervalValue: ResponseDataValueT;
    xKey: string;
    xValue: NotNullDataValueT;
}): Record<string, [number, number]> => {
    // not sure if/when the fallback to xValue is necessary
    const intervalValueMedian = intervalValue ?? xValue;
    const parsedIntervalValueMedian = parseFloat(
        intervalValueMedian.toString(),
    );
    // We have an histogram, we add a filter to take the entire interval into account
    const minBinValue = parsedIntervalValueMedian - interval / 2;
    const maxBinValue = parsedIntervalValueMedian + interval / 2;
    return { [xKey]: [minBinValue, maxBinValue] };
};
